import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FacultyService } from '../../services/faculty.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'generate-report',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './generate-report.component.html',
  styleUrl: './generate-report.component.css'
})
export class GenerateReportComponent implements OnInit {
  batches: any[] = [];
  roundList: any[] = [];


  selectedBatch: string = '';
  selectedRound: string = '';
  facultyId: number = 0;

  selectedReport: any = '';
  reportList = [
    { value: 1, key: 'Batch Summary Report' },
    { value: 2, key: 'Round Wise Report' },
    { value: 3, key: 'Final Evaluation Report' }
  ];
  constructor(private facultyService: FacultyService, private toaster: ToastrService, private loader: LoaderService) { }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.facultyId = user.userId;
    this.loadBatches();
    this.loadReportList();
  }

  async generateReport(): Promise<void> {
    this.loader.showLoader();
    if (this.selectedBatch && this.selectedRound) {
      this.facultyService.generateReport(this.facultyId, this.selectedBatch, this.selectedRound).subscribe({
        next: async (res) => {
          this.toaster.success(res.errorDescription || 'Report generated successfully', 'Success')
          this.loader.hideLoader();
          // await this.downloadReport(res.Data.dirPath);
          this.loadReportList();
        },

        error: (err) => {
          this.toaster.error('Error generating report: ' + err.message, 'Error'),
            this.loader.hideLoader();
        }
      });
    }
  }

  downloadReport(): void {
    this.facultyService.downloadReport(this.selectedReport).subscribe({
      next: (blob: Blob) => {
        const selectedReportObj = this.reportList.find(
          rep => rep.value == this.selectedReport
        );

        const fileName = `Excel_Report_${selectedReportObj?.key}.zip`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
        // this.toaster.success('Excel ZIP downloaded successfully', 'Success');
      },
      error: (err) =>
        this.toaster.error(
          'Error downloading report: ' + err.message,
          'Error'
        )
    });
  }



  resetForm() {
    this.selectedBatch = '';
    this.selectedRound = '';
    this.roundList = [];
    this.selectedReport = '';
  }

  loadBatches(): void {
    this.facultyService.getBatches(this.facultyId).subscribe({
      next: (batchdata) => (this.batches = batchdata.Data),
      error: (err) => console.error('Error loading batches:', err)
    });
  }

  onBatchChange(): void {
    this.selectedRound = '';
    this.roundList = [];
    const batch = this.batches.find(b => b.SDBatchId == this.selectedBatch);
    if (!batch || !batch.RoundsPlayed) {
      return;
    }
    const totalRounds = Number(batch.RoundsPlayed);
    this.roundList = Array.from(
      { length: totalRounds },
      (_, index) => index + 1
    );

  }



  loadReportList(): void {
    this.facultyService.getReportList().subscribe({
      next: (batchdata) => (this.reportList = batchdata.Data),
      error: (err) => console.error('Error loading batches:', err)
    });
  }

}
